module.exports = __webpack_public_path__ + "static/img/2.53e4941.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-maquinaria-equipo-contratistas/2.png
// module id = +arT
// module chunks = 0